import { memo } from 'react';

import type { PlanRevampIconProperties } from './types';

const CELL_WIDTH = 4.2;
const CELL_HEIGHT = 6.2;
const GAP_X = 1.4;
const GAP_Y = 1.6;

/**
 * Blox-Design plan toolbar — group-by grid (node 75644:10724).
 * 3 columns × 2 rows of filled squares.
 */
const PlanToolbarGroupByIcon = ({
  width = 16,
  height = 16,
  color = 'currentColor',
}: PlanRevampIconProperties) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden
  >
    {[0, 1, 2].flatMap((column) =>
      [0, 1].map((row) => (
        <rect
          key={`${column}-${row}`}
          x={column * (CELL_WIDTH + GAP_X)}
          y={row * (CELL_HEIGHT + GAP_Y)}
          width={CELL_WIDTH}
          height={CELL_HEIGHT}
          rx={0.6}
          fill={color}
        />
      )),
    )}
  </svg>
);

export default memo(PlanToolbarGroupByIcon);
